import { useLocation, useNavigate } from "@tanstack/react-router";
import { ReactNode } from "react";
import { useGetAllOmroepen } from "../../functions/apiFunctions/getAllOmroepen";
import { useMediaUrls } from "../../hooks/useMediaUrls";

export type TvChannelOverviewProps = {
  notFoundComponent: ReactNode;
};

export function TvChannelOverview({ notFoundComponent }: TvChannelOverviewProps) {
  const omroepen = useGetAllOmroepen();
  const logoUrls = useMediaUrls(omroepen.data?.data.map((omroep) => omroep.acf.kabelkrant_logo) ?? []);
  const navigate = useNavigate();
  // Check current page url with tanstack router
  const location = useLocation();

  function openOmroep(slug: string) {
    navigate({
      to: location.href.includes("overview") ? "/$omroep/Overview" : "/$omroep",
      params: {
        omroep: slug
      }
    });
  }

  return (
    <div className="text-white">
      <div className="flex h-screen w-screen flex-col items-center justify-center gap-12">
        <div>{notFoundComponent}</div>
        <div className="flex gap-12">
          {omroepen.data?.data.map((omroep) => (
            <button onClick={() => openOmroep(omroep.slug)} className="flex flex-col items-center justify-center gap-6 rounded-md bg-white p-6 text-xl font-semibold text-black">
              {logoUrls[omroep.acf.kabelkrant_logo] != null && <img className="size-52 object-contain" src={logoUrls[omroep.acf.kabelkrant_logo]} alt="logo" />}
              <div> {omroep.title.rendered} </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
